import {isFeatureEnabled} from '@github-ui/feature-flags'
import type {APITask} from '../types/api-task'
import {getChannelOrigin, type ChannelOrigin} from '../types/origin'
import type {Session} from '../types/session'
import {SessionState} from '../types/session'

export const CHANNEL_HISTORY_POLL_MS = 10_000

export function getChannelSessionOrigin(session: Session | null | undefined): ChannelOrigin | null {
  return getChannelOrigin(session?.event_type)
}

export function isChannelSession(session: Session | null | undefined): boolean {
  return getChannelSessionOrigin(session) !== null
}

export interface MessagingAppDmSteeringInput {
  session: Session | null | undefined
  creatorType: APITask['creator_type'] | undefined
  viewerOwnsSession: boolean
}

/**
 * A user-owned Slack or Teams DM session can be steered live by its owner. DMs are inferred from
 * `creator_type === 'user'`: Slack and Teams create DM tasks with the user's token and channel
 * tasks with the app's. Channel sessions, unknown creators, other viewers, and sessions without a
 * bound AHP environment keep the read-only history.
 */
export function canSteerMessagingAppDm({
  session,
  creatorType,
  viewerOwnsSession,
}: MessagingAppDmSteeringInput): boolean {
  return (
    isChannelSession(session) &&
    creatorType === 'user' &&
    viewerOwnsSession &&
    !!session?.environment_id &&
    isFeatureEnabled('copilot_mission_control_environments_web_kickoff') &&
    isFeatureEnabled('copilot_mission_control_messaging_app_dm_steering')
  )
}

/**
 * Polls persisted AHP events while the session is running, then stops once it
 * settles. Polling is the liveness mechanism for these read-only timelines,
 * which get no owner-only Alive push.
 */
export function channelHistoryRefetchInterval(session: Session | null | undefined): number | false {
  return session?.state === SessionState.InProgress ? CHANNEL_HISTORY_POLL_MS : false
}
